import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ISignInRequest } from '@shared/model/sign-in.model';
import { AuthViewEnum } from '../../enums/auth-step-enum';
import { NgClass } from '@angular/common';
import { ForgetFlowStepEnum } from '../../enums/forget-flow-step-enum';
import { StandardNumberDirective } from '@shared/utils/standard-number.directive';
import { ButtonLoaderDirective } from '@shared/directive/button-loader/button-loader.directive';

@Component({
    selector: 'app-login-form-presenter',
    imports: [
        ReactiveFormsModule,
        NgClass,
        ButtonLoaderDirective,
        StandardNumberDirective
    ],
    templateUrl: './login-form-presenter.component.html',
    styleUrl: './login-form-presenter.component.scss'
})
export class LoginFormPresenterComponent implements OnInit {
  private fb = inject(FormBuilder);


  @Input() loginLoading = false;
  @Input() step!: ForgetFlowStepEnum;
  @Output() onLoginSubmitted = new EventEmitter<ISignInRequest>();
  @Output() onOtpDesired = new EventEmitter<AuthViewEnum>();
  @Output() onForgetPassDesired = new EventEmitter<AuthViewEnum>();

  form!: FormGroup;
  passwordVisible = false;

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      userName: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
    });
  }

  submit() {
    const data: ISignInRequest = {
      grandType: 'password',
      isOtp: false,
      username: this.form.get('userName')?.value,
      password: this.form.get('password')?.value,
      input_type: null,

    };
    this.onLoginSubmitted.emit(data);
  }

  loginWithOtp() {
    this.onOtpDesired.emit(AuthViewEnum.userName);
  }

  forgetPassword() {
    this.onForgetPassDesired.emit(AuthViewEnum.forget_pass);
  }


}
